import "./HeroImgStyles.css";
import { React } from "react";

import IntroImg from "../../assets/intro-bg.jpg";
import { Link } from "react-router-dom";
// import config from "../components/contact/config";
import config from "../contact/config";
export const HeroImg = () => {
  const myDesignation = config.myDesignation;
  const myCurrentRole = config.myCurrentRole;
  return (
    <div className="hero">
      <div className="mask">
        <img className="into-img" src={IntroImg}  alt="{myCurrentRole} {myDesignation}" />
      </div>

      <div className="content">
        <p>HI, I'M A {myDesignation}.</p>
        
        <h1>{myCurrentRole}</h1>
        <div>
          <Link to="/project" className="btn">
            Projects
          </Link>
          <Link to="/contact" className="btn btn-light">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

